import * as  moment from "../../../node_modules/moment/moment";
import { OepDocument } from "../../OepDocument";

class InscriptionFile extends OepDocument {
    private _type: number;
    private _requirementId: string;
    private _fileName: string;
    private _fileDate: moment.Moment;
    private _loading: boolean;
    private _evaluableConditionType: number;
    private _meritGroupId: string;
    private _meritSubGroupId: string;
    private _meritId: string;
    private _examId: string;
    private _status: number;
    private _uploader: any;

    constructor(data: any) {
        super(data);
        this._type = data.evaluableConditionType;
        this._requirementId = data.requirementId;
        this._meritGroupId = data.meritGroupId;
        this._meritSubGroupId = data.meritSubGroupId;
        this._meritId = data.meritId;
        this._examId = data.examId;
        this._fileName = data.fileName;
        this._loading = data.loading;
        this._fileDate = moment.utc(data.fileDate);
        this._status = data.status;
        this._uploader = data.uploader;
    }

    public get type(): number {
        return this._type;
    }
    public get fileDate(): moment.Moment {
        return this._fileDate;
    }
    public get fileName(): string {
        return this._fileName;
    }
    public set fileName(fileName: string) {
        this._fileName = fileName;
    }
    public get requirementId(): string {
        return this._requirementId;
    }
    public get loading(): boolean {
        return this._loading;
    }
    public set loading(loading: boolean) {
        this._loading = loading;
    }
    public get evaluableConditionType(): number {
        return this._evaluableConditionType;
    }
    public get meritGroupId(): string {
        return this._meritGroupId;
    }
    public get meritSubGroupId(): string {
        return this._meritSubGroupId;
    }
    public get meritId(): string {
        return this._meritId;
    }
    public get examId(): string {
        return this._examId;
    }
    public set evaluableConditionType(evaluableConditionType: number) {
        this._evaluableConditionType = evaluableConditionType;
    }
    public get status() {
        return this._status;
    }
    public get uploader() {
        return this._uploader;
    }

    public isValidFileToUpload(newFile: any): boolean {
        return newFile.name === this._fileName;
    }
}

export { InscriptionFile };